import type { MouseEvent, KeyboardEvent } from 'react';

export const isNormalClick = (e: MouseEvent | KeyboardEvent) =>
	!(('button' in e && e.button) || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
